import React from 'react';
import { Alert, Container, Grid } from '@mui/material';

type ErrorFallbackProps = {
  error?: Error | string;
};

const ErrorFallback = ({ error = 'Something went wrong.' }: ErrorFallbackProps) => {
  return (
    <Container>
      <Grid container justifyContent="center">
        <Alert severity="error">{error.toString()}</Alert>
      </Grid>
    </Container>
  );
};

export default ErrorFallback;
